var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isJustDropped
      ? _c("div", { staticClass: "product-badge" }, [
          _vm._v("\n    " + _vm._s(_vm.badgeJustDroppedText) + "\n  "),
        ])
      : _vm.isComingSoon
      ? _c("div", { staticClass: "product-badge" }, [
          _vm._v("\n    " + _vm._s(_vm.badgeComingSoonText) + "\n  "),
        ])
      : _vm.priorityBadgeText
      ? _c("div", { staticClass: "product-badge" }, [
          _vm._v("\n    " + _vm._s(_vm.priorityBadgeText) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }